export const typography = {
  fontFamily: 'Roobert, sans-serif',
};
